import React from 'react';
import {connect} from 'react-redux';
import {List} from 'immutable';
import {defineMessages, FormattedMessage} from 'react-intl';

import * as BetTypes from 'constants/BetType';
import * as CouponState from 'constants/CouponState';

import {setCouponBetType as setCouponBetTypeAction} from 'actions/creators/CouponRate';

const messages = defineMessages({
    ordinar: {
        id: 'bet_type.ordinar',
        defaultMessage: 'Ординар'
    },
    accumulator: {
        id: 'bet_type.accumulator',
        defaultMessage: 'Экспресс'
    },
    looseToWinAccumulator: {
        id: 'bet_type.looseToWinAccumulator',
        defaultMessage: 'Антиэкспресс'
    },
    system: {
        id: 'bet_type.system',
        defaultMessage: 'Система {rank} из {count}'
    },
    betType: {
        id: 'coupon.bet_type_hint',
        defaultMessage: 'Тип ставки'
    }
});

class BetType extends React.Component {
    static propTypes = {
        languageId: React.PropTypes.number.isRequired,
        betTypes: React.PropTypes.instanceOf(List),
        antiExpressOdd: React.PropTypes.number,
        couponState: React.PropTypes.number.isRequired,
        currentBetTypeIndex: React.PropTypes.number,
        setCouponBetTypeAction: React.PropTypes.func.isRequired
    };

    static renderBetType(betType, index) {
        let message = null;

        switch (betType.type) {
            case BetTypes.SINGLE:
                message = messages.ordinar;
                break;

            case BetTypes.EXPRESS:
                message = messages.accumulator;
                break;

            case BetTypes.SYSTEM:
                message = messages.system;
                break;

            case BetTypes.ANTIEXPRESS:
                message = messages.looseToWinAccumulator;
                break;
        }

        return (
            <FormattedMessage key={index} {...message} values={betType}>
                {(message) => <option value={index}>{message}</option>}
            </FormattedMessage>
        );
    }

    constructor(props) {
        super(props);

        this._onBetTypeChanged = this._onBetTypeChanged.bind(this);
    }

    shouldComponentUpdate(nextProps) {
        return nextProps.languageId !== this.props.languageId ||
            this.props.betTypes !== nextProps.betTypes ||
            this.props.couponState !== nextProps.couponState ||
            this.props.currentBetTypeIndex !== nextProps.currentBetTypeIndex;
    }

    _onBetTypeChanged(e) {
        e.preventDefault();

        const index = parseInt(e.target.value);

        this.props.setCouponBetTypeAction(index);
    }


    render() {
        const {betTypes, currentBetTypeIndex, couponState} = this.props;

        if (couponState === CouponState.DISABLED || currentBetTypeIndex === -1) {
            return (
                <div className="bet-type">
                    <select disabled="disabled"/>
                    <span className="select-chevron-down">{'\u00A0'}</span>
                </div>);
        }

        return (
            <FormattedMessage {...messages.betType}>
                {(message) =>
                    <div className="bet-type" title={message} >
                        <select value={currentBetTypeIndex} onChange={this._onBetTypeChanged}>
                            {betTypes.map(bt => BetType.renderBetType(bt, betTypes.indexOf(bt)))}
                        </select>
                        <span className="select-chevron-down">{'\u00A0'}</span>
                    </div>}
            </FormattedMessage>
        );
    }
}

function select(state) {
    const languageId = state.application.get('languageId');
    const betTypes = state.application.getIn(['coupon', 'betTypes']);
    const currentBetTypeIndex = state.application.getIn(['coupon', 'currentBetTypeIndex']);
    const couponState = state.application.getIn(['coupon', 'state']);

    return {
        languageId,
        betTypes,
        couponState,
        currentBetTypeIndex
    };
}

export default connect(select, {setCouponBetTypeAction})(BetType);


// WEBPACK FOOTER //
// ./js/sport-betting/components/bet-panel-control/coupon/BetType.jsx